import { IProgramType } from 'legacy/lut/features/partner360/configuration'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { FC, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'

import { ProgramTypesEditorModal } from './components/programTypesEditorModal/ProgramTypesEditorModal'

interface IProgramTypesEditorProps {
  partnerId: string
  fYear: number
  programTypes: IProgramType[]
}

export const ProgramTypesEditor: FC<IProgramTypesEditorProps> = ({
  partnerId,
  fYear,
  programTypes,
}) => {
  const [showEditorModal, setShowEditorModal] = useState(false)

  const isEditMode = useSelector(selectPublishingMode)
  const { isPartnerUser } = useUserRoles()
  const translationMode = useSelector(selectTranslationMode)

  const toggleEditorModal = useCallback(() => {
    setShowEditorModal((prevState) => !prevState)
  }, [])

  const renderTooltipContent = useCallback(() => {
    return (
      <div>
        <Translation text="jbp-partner-program-types-edit" actionsInside />
      </div>
    )
  }, [])

  if (isPartnerUser || !isEditMode) {
    return null
  }

  if (translationMode === 'edit') {
    return <Translation text="jbp-partner-program-types-edit" actionsInside />
  }

  return (
    <>
      <Tooltip inline tipContent={renderTooltipContent}>
        <Button iconButton="kbase kbase-settings" variant="text" onClick={toggleEditorModal} />
      </Tooltip>
      <ProgramTypesEditorModal
        partnerId={partnerId}
        fYear={fYear}
        programTypes={programTypes}
        shouldShowModal={showEditorModal}
        onClose={toggleEditorModal}
      />
    </>
  )
}
